"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../Icon"));

require("./_text.scss");

var textTypes = {
  heading1: {
    element: "h1",
    iconSize: 40
  },
  heading2: {
    element: "h2",
    iconSize: 30
  },
  heading3: {
    element: "h3",
    iconSize: 25
  },
  heading4: {
    element: "h4",
    iconSize: 20
  },
  heading5: {
    element: "h5",
    iconSize: 15
  },
  body: {
    element: "p",
    iconSize: 15
  },
  caption: {
    element: "p",
    iconSize: 15
  },
  timestamp: {
    element: "p",
    iconSize: 15
  },
  label: {
    element: "p",
    iconSize: 15
  },
  placeholder: {
    element: "p",
    iconSize: 15
  },
  subtitle: {
    element: "p",
    iconSize: 15
  },
  button: {
    element: "span",
    iconSize: 15
  },
  link: {
    element: "span",
    iconSize: 15
  }
};

function getTextEl(a) {
  var b = Object.keys(textTypes).find(function (b) {
    return a[b];
  }) || "body",
      c = textTypes[b],
      d = c.element,
      e = c.iconSize;
  return {
    type: b,
    TextEl: d,
    iconSize: e
  };
}

function getDagger() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = a.suffix,
      c = a.double,
      d = b ? "suffix" : "prefix";
  return _react["default"].createElement("sup", {
    className: "text__".concat(d, "-dagger")
  }, c ? "\u2021" : "\u2020");
}

function Text(a) {
  var b = a.children,
      c = a.className,
      d = a.disabled,
      e = a.noMargin,
      f = a.darkTheme,
      g = a.prefixDagger,
      h = a.prefixDoubleDagger,
      i = a.suffixDagger,
      j = a.suffixDoubleDagger,
      k = a.required,
      l = a.highlighted,
      m = a.success,
      n = a.danger,
      o = a.warning,
      p = a.neutral,
      q = a.ellipsisOverflow,
      r = a.centered,
      s = a.prefixIcon,
      t = a.prefixIconColor,
      u = a.suffixIcon,
      v = a.suffixIconColor,
      w = (0, _objectWithoutProperties2["default"])(a, ["children", "className", "disabled", "noMargin", "darkTheme", "prefixDagger", "prefixDoubleDagger", "suffixDagger", "suffixDoubleDagger", "required", "highlighted", "success", "danger", "warning", "neutral", "ellipsisOverflow", "centered", "prefixIcon", "prefixIconColor", "suffixIcon", "suffixIconColor"]),
      x = getTextEl(w),
      y = x.type,
      z = x.TextEl,
      A = x.iconSize;
  return l && "body" !== y && console.warn("You can only highlight body text."), _react["default"].createElement(z, {
    className: (0, _classnames["default"])("text", "text--".concat(y), {
      "text--disabled": d,
      "text--no-margin": e && "string" != typeof e,
      "text--no-margin-bottom": "bottom" === e,
      "text--no-margin-top": "top" === e,
      "text--dark-theme": f,
      "text--ellipsis-overflow": q,
      "text--centered": r,
      "text--highlighted": "body" === y && l,
      "text--success": m,
      "text--danger": n,
      "text--warning": o,
      "text--neutral": p
    }, c)
  }, g && getDagger(), h && getDagger({
    double: !0
  }), s && "button" !== y ? _react["default"].createElement(_Icon["default"], {
    className: "text__prefix-icon",
    name: s,
    color: t,
    size: A
  }) : null, b, u && "button" !== y ? _react["default"].createElement(_Icon["default"], {
    className: "text__suffix-icon",
    name: u,
    color: v,
    size: A
  }) : null, k && _react["default"].createElement("span", {
    className: "text__asterisk"
  }, "*"), i && getDagger({
    suffix: !0
  }), j && getDagger({
    suffix: !0,
    double: !0
  }));
}

Text.displayName = "Text";

var _default = (0, _react.memo)(Text);

exports["default"] = _default;